import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function SorterDescIcon(props: SvgIconProps) {
  const defaultColor = '#B8BABF';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 11 22'
    >
      <path
        d='M9.46854 9.06177H1.53146C1.2934 9.06177 1.16047 8.81041 1.3079 8.63881L5.27644 4.03705C5.39003 3.90532 5.60876 3.90532 5.72356 4.03705L9.6921 8.63881C9.83953 8.81041 9.7066 9.06177 9.46854 9.06177Z'
        fill={props.color ?? '#4760F6'}
      />
      <path
        d='M9.6921 12.3612L5.72356 16.963C5.60997 17.0947 5.39124 17.0947 5.27644 16.963L1.3079 12.3612C1.16047 12.1896 1.2934 11.9383 1.53146 11.9383H9.46854C9.7066 11.9383 9.83953 12.1896 9.6921 12.3612Z'
        fill={defaultColor}
      />
    </SvgIcon>
  );
}
